import request from '@/utils/request'

// 获取云端上传临时上传密钥
export function generateKeys (data) {
  return request({
    url: '/common/upload-file/generate-temp-keys',
    method: 'POST',
    data
  })
}

// 获取系统配置信息信息
export function getsystemconfig (params) {
  return request({
    url: '/common/system-config/get-info',
    method: 'get',
    params
  })
}


// 文件删除
export function deleteFile (data) {
  return request({
    url: '/common/upload-file/delete',
    method: 'post',
    data
  })
}

// 查看/下载文件
export function uploaddownloadfile (data) {
  return request({
    url: '/common/upload-file/download-file',
    method: 'post',
    data
  })
}

// 获取当前管理员的头像等欢迎信息
export function getuserinfo (params) {
  return request({
    url: '/common/auth/user-info?t=' + new Date().getTime(),
    method: 'get',
    params
  })
}

// 获取当前登录人的im用户信息
export function getimuserinfo (params) {
  return request({
    url: '/common/im/get-user-info',
    method: 'GET',
    params
  })
}

// 获取当前登录人的llm的token
export function getWStoken (params) {
  return request({
    url: '/common/llm/get-ws-token',
    method: 'GET',
    params
  })
}